import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { useDeleteRefereeDutyMutation } from '../../mutation';
import { useRefereeDutiesListQuery } from '../../queries';
import { Table } from '~/components/Table/Table';
import { Panel } from '~/components/Panel/Panel';
import { Fragment } from 'react/jsx-runtime';
import { JudgeDuty } from '~/apis/ssf';
import { useSortableTable } from '~/hooks/useSortableTable';

interface Props {
  competitionId: number;
}

function Row({ results, onDelete }: { results: JudgeDuty; onDelete: (id: number) => void }) {
  return (
    <Table.Row>
      <Table.Col>{`${results.judge_license.judge.person.first_name} ${results.judge_license.judge.person.last_name}`}</Table.Col>
      <Table.Col>{results.group.name}</Table.Col>
      <Table.Col>{results.role.description}</Table.Col>
      <Table.Col align="right">
        <Table.Context
          items={[<ContextMenu.Item label="Ta bort" key="delete" onClick={() => onDelete(results.id)} danger />]}
        />
      </Table.Col>
    </Table.Row>
  );
}

export function RefereeDutiesListTable({ competitionId }: Props) {
  const { register, values } = useSortableTable('group_name,role_name');

  const { data, isLoading } = useRefereeDutiesListQuery({
    competition: competitionId,
    ordering: values.ordering,
  });

  const deleteMutation = useDeleteRefereeDutyMutation();

  async function handleDelete(id: number) {
    await deleteMutation.mutateAsync(id);
  }

  if (!isLoading && data?.results.length === 0) {
    return (
      <Panel variant="informative" size="sm">
        <p>Inga domaruppdrag är tilldelade ännu. Sök efter en domare ovan för att tilldela ett uppdrag.</p>
      </Panel>
    );
  }

  return (
    <Fragment>
      <Table bg="even">
        <Table.Head>
          <Table.Row>
            <Table.Col as="th" {...register('judge_first_name,judge_last_name')}>
              Namn
            </Table.Col>
            <Table.Col as="th" {...register('group_name')}>
              Grupp
            </Table.Col>
            <Table.Col as="th" {...register('role_name')}>
              Roll
            </Table.Col>
            <Table.Col as="th" />
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {isLoading ? (
            <Table.Loading cols={12} />
          ) : (
            data?.results.map(results => <Row results={results} key={results.id} onDelete={handleDelete} />)
          )}
        </Table.Body>
      </Table>
    </Fragment>
  );
}
